// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql } from 'react-apollo';

import { revokeAutoMessageSftpCredentials } from 'admin/actions/AutoMessageSftpCredentialsActions';

import GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG from './queries/AdminAutoMessageSftpCredentialsQuery.gql';

type Props = {
  children: (props: {
    loading: ?boolean,
    autoMessageSftpCredentials: ?*,
    onCredentialDeletion: (name: string) => void,
    refetch: ?() => void,
  }) => React.Node,
  data: ReactApolloData<*>,
  organizationUUID: string,
};

class AdminAutoMessageSftpCredentialsContainer extends React.Component<Props, void> {
  render() {
    const { data, children } = this.props;

    return children({
      onCredentialDeletion: username =>
        revokeAutoMessageSftpCredentials(username, this.props.organizationUUID),
      refetch: idx(data, _ => _.refetch),
      loading: idx(data, _ => _.loading),
      autoMessageSftpCredentials: idx(data, _ => _.autoMessaging.sftpCredentials),
    });
  }
}

const withAutoMessageSftpCredentials = graphql(GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG, {
  options: ({ organizationUUID }) => ({
    variables: { orgUuid: organizationUUID },
  }),
});

export { AdminAutoMessageSftpCredentialsContainer };

export default withAutoMessageSftpCredentials(AdminAutoMessageSftpCredentialsContainer);
